/* eslint-disable max-len */
import { SvgProps } from './types'

export const CalculatorIcon = ({ color, className }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg 
      width="20" 
      height="30" 
      viewBox="0 0 20 30" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_297_20094)">
        <path d="M17.4586 1.03558H2.713C1.89314 1.03558 1.22852 1.70021 1.22852 2.52007V27.1985C1.22852 28.0184 1.89314 28.683 2.713 28.683H17.4586C18.2785 28.683 18.9431 28.0184 18.9431 27.1985V2.52007C18.9431 1.70021 18.2785 1.03558 17.4586 1.03558Z" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M15.8091 3.75873H4.39648V9.80069H15.8091V3.75873Z" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M7.7288 13.9894L4.01758 17.7006" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M7.7288 17.7006L4.01758 13.9894" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M16.2389 15.7528H10.9912" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11.7617 25.5863L15.4682 21.8751" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M15.3076 25.4209L15.3596 25.4776" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11.8799 21.9933L11.9413 22.0548" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.49966 23.7284H3.25195" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M5.87598 26.3523V21.1046" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_297_20094">
          <rect width="19.8" height="30" fill="white" transform="translate(0 -0.00805664)"/>
        </clipPath>
      </defs>
    </svg>
  )
}
